export interface Post {
  slug: string;
  title: string;
  description: string;
  category: string;
  author: string;
  date: string; // ISO
  readingTime: string;
  cover: string; // emoji or gradient hint
  excerpt: string;
  content: { heading: string; body: string }[];
  faq?: { q: string; a: string }[];
}

export const CATEGORIES = [
  "SEO",
  "Google Meu Negócio",
  "Criação de Sites",
  "SEO Local",
  "Marketing Digital",
  "Estratégias para Empresas",
] as const;

// Os artigos agora vivem no banco de dados (tabela public.posts) e são gerados
// pela ferramenta de blog do painel administrativo. Mantemos a lista vazia
// apenas como compatibilidade de tipo para imports legados.
export const POSTS: Post[] = [];

export const findPost = (slug: string) => POSTS.find((p) => p.slug === slug);
export const relatedPosts = (slug: string, limit = 3) =>
  POSTS.filter((p) => p.slug !== slug).slice(0, limit);